import axios from 'axios';
import SessionService from './SessionService';
import { API_URL } from '../config/api';
import appCache from './AppCache';
import type { DashboardStatsDTO } from '../types/pagedAndDtos';

export const getDashboardStats = async (sectorId: number, forceRefresh = false): Promise<DashboardStatsDTO> => {
  const token = SessionService.getToken();
  if (!token) throw new Error('Authentication token not found');

  const cacheKey = `dashboard:${sectorId}`;
  if (!forceRefresh) {
    const cached = appCache.get<DashboardStatsDTO>(cacheKey);
    if (cached) return cached;
  }

  const response = await axios.get<DashboardStatsDTO>(`${API_URL}/dashboard/stats`, {
    params: { sectorId },
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  appCache.set(cacheKey, response.data, 5 * 60 * 1000);
  return response.data;
};
